export default __webpack_public_path__ + "static/media/BRZw.8e519e6d.png";